export type TData = {
  [index: string]: any
}[]

export type TFilters = {
  status: string
  keyword: string
  assignee_crm_user_id: string
  from: string
  to: string
  date: string
}

export type TViewMode = 'list' | 'daily'

export type TSort = {
  sort_by: string
  sort: string
}

export const AI_CALL_STATUS_OPTIONS = [
  {
    label: 'Any status',
    value: '',
  },
  {
    label: 'Awaiting support',
    value: 'awaiting_support',
  },
  {
    label: 'Awaiting restaurant',
    value: 'awaiting_restaurant',
  },
  {
    label: 'Closed',
    value: 'closed',
  },
]

export const AI_CALL_EDIT_STATUS_OPTIONS = AI_CALL_STATUS_OPTIONS.filter(
  item => item.value,
)

export const AI_CALL_STATUS_MAP: Record<
  string,
  {
    text: string
    color: 'blue' | 'green' | 'yellow' | 'orange' | 'red' | 'default'
  }
> = {
  awaiting_support: {
    text: 'Awaiting support',
    color: 'yellow',
  },
  awaiting_restaurant: {
    text: 'Awaiting restaurant',
    color: 'orange',
  },
  closed: {
    text: 'Closed',
    color: 'green',
  },
}

export const getStatusText = (value?: string) => {
  if (!value) {
    return '-'
  }
  return AI_CALL_STATUS_MAP[value]?.text || value
}

export const getPersonDisplayName = (person?: any) => {
  if (!person) {
    return '-'
  }

  const user = person.user || person
  const firstName = user.first_name || person.first_name || ''
  const lastName = user.last_name || person.last_name || ''
  const name = `${firstName} ${lastName}`.trim()

  return name || person.name || user.name || '-'
}

export const getPersonAvatar = (person?: any) => {
  if (!person) {
    return ''
  }
  return person.profile_photo || person.crm_user?.profile_photo || ''
}
